import MicrosoftDynamics365Logo from '@/assets/icons/microsoft-dynamics-365-logo.svg?react';
import { CustomConnectorDestinationItem } from '@/features/destinations/components/customConnectors';
import { CustomConnectorDto } from '@/models/connectors';
import { DistributionChannelConnector } from '@/models/distributionChannels';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';
import { CatalogDestinationItem } from './CatalogDestinationItem';
import { ComingSoonDestinationItem } from './ComingSoonDestinationItem';

type DataCatalogDestinationGridProps = {
  dataDestinations: DistributionChannelConnector[];
  customConnectors?: CustomConnectorDto[];
  className?: string;
};

export const DataCatalogDestinationGrid: FC<DataCatalogDestinationGridProps> = ({
  dataDestinations,
  customConnectors = [],
  className,
}) => {
  const { t } = useTranslation('COMMON');

  const [connectedConnector, disconnectedConnector] = useMemo(() => {
    return dataDestinations.reduce(
      ([connected, disconnected], connector) =>
        connector.installed && connector.authenticated ? [[...connected, connector], disconnected] : [connected, [...disconnected, connector]],
      [[], []]
    );
  }, [dataDestinations]);

  const [connectedCustomConnectors, disconnectedCustomConnectors] = useMemo(() => {
    return customConnectors.reduce(
      ([connected, disconnected], connector) => {
        const isConnected = connector.isAuthenticated;
        return isConnected ? [[...connected, connector], disconnected] : [connected, [...disconnected, connector]];
      },
      [[], []]
    );
  }, [customConnectors]);

  return (
    <div className='flex flex-col'>
      <p className='p-4 text-base font-semibold text-brand-600 first-letter:uppercase'>{t('highlighted')}</p>

      {(connectedConnector.length > 0 || connectedCustomConnectors.length > 0) && (
        <div className={twMerge(`flex flex-wrap gap-4 justify-start pt-2 pb-4`, className)}>
          {connectedConnector.map((connector) => (
            <CatalogDestinationItem key={connector.name} connector={connector} />
          ))}
          {connectedCustomConnectors.map((connector) => (
            <CustomConnectorDestinationItem key={connector.id} connector={connector} />
          ))}
        </div>
      )}

      <div className={twMerge(`flex flex-wrap gap-4 justify-star pt-4 pb-2 border-t`, className)}>
        {disconnectedConnector.map((connector) => (
          <CatalogDestinationItem key={connector.name} connector={connector} />
        ))}
        {disconnectedCustomConnectors.map((connector) => (
          <CustomConnectorDestinationItem key={connector.id} connector={connector} />
        ))}
        <ComingSoonDestinationItem name='Microsoft Dynamics' icon={<MicrosoftDynamics365Logo className='size-16' />} />
      </div>
    </div>
  );
};
